export default __webpack_public_path__ + "images/OF.d3a2096.png";